export const itemAttributeModel = {
    attributeName: "",
    attributeValue: "",
};
